import {
  UI_SET_LOADER,
  UI_SET_LOADER_TEXT,
  SET_UI_PROPERTY,
  UI_UPDATE_TOWNS_BY_CP_CACHE,
  UI_UPDATE_MASTER_DATA,
  UI_GET_CHEKINOUT_MASTER_DATA,
  UI_GET_TIRES_MASTER_DATA,
  RESET_INFORMATION_TIRES,
  UI_GET_MUNICIPALITIES
} from 'store/actions/ui';
import { setValueObjectByField, mapOptionsMasterData } from 'helpers/object';
import { TIRES_DEFAULT_VALUE } from 'store/enums';

export default {
  [SET_UI_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [UI_SET_LOADER]: (state, loading) => {
    state.loader = loading;
  },

  [UI_SET_LOADER_TEXT]: (state, text) => {
    state.loaderText = text;
  },

  [UI_UPDATE_TOWNS_BY_CP_CACHE]: (state, { cp, towns }) => {
    state.townsCache[cp] = towns;
  },

  [UI_UPDATE_MASTER_DATA]: (state, data) => {
    const { streetType, maritalStatus, profession, sex, signType } = data;
    Object.assign(state, { streetType, maritalStatus, profession, sex, signType });
  },

  [UI_GET_CHEKINOUT_MASTER_DATA]: (state, data) => {
    const propertiesToMap = [
      'storageParks',
      'fuelTank',
      'cleaning',
      'wheels',
      'transportProviders',
      'brandTires',
      'provinces',
      'spareWheels'
    ];
    propertiesToMap.forEach(prop => {
      state.checkinoutMasterData[prop] = data[prop] ? mapOptionsMasterData(data[prop]) : [];
    });
  },

  [UI_GET_TIRES_MASTER_DATA]: (state, { data, type }) => {
    const sourceProperties = [
      'speedTires',
      'loadTires',
      'diameterTires',
      'heightTires',
      'widthTires'
    ];
    state.informationTires[type] = sourceProperties.reduce((acc, sourceProp) => {
      const propertyOptions = `${sourceProp}Options`;
      acc[propertyOptions] = data[sourceProp] ? mapOptionsMasterData(data[sourceProp]) : [];
      return acc;
    }, {});
  },

  [RESET_INFORMATION_TIRES]: state => {
    state.informationTires = TIRES_DEFAULT_VALUE;
  },

  [UI_GET_MUNICIPALITIES]: (state, data) => {
    const { municipalities } = data;
    state.checkinoutMasterData.municipalities = mapOptionsMasterData(municipalities);
  }
};
